import { cn } from "./_utils";

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Animated placeholder block. Pass `className` to size it.
 *
 * @example
 * <Skeleton className="h-4 w-32" />
 * <Skeleton className="h-24 w-full" />
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        "animate-pulse bg-[var(--print-bg)] rounded-[var(--radius-control)]",
        className
      )}
      aria-hidden="true"
      {...props}
    />
  );
}
